import React from 'react';
import { useInView } from '../hooks/useInView';
import { CTAButton } from './CTAButton';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CHECKOUT_URL = 'https://italia.edulabs.online/cart/43322157400182:1';
export function PricingSection() {
  const {
    ref,
    isVisible
  } = useInView();
  const handleCheckout = () => {
    trackAddToCart();
    window.open(CHECKOUT_URL, '_blank');
  };
  return <section id="pricing" className="bg-white py-12 md:py-20 px-4 border-t border-gray-100" data-id="element-83">
      <div className="max-w-xl mx-auto" data-id="element-84">
        <div ref={ref} className={`fade-in ${isVisible ? 'is-visible' : ''}`} data-id="element-85">
          <div id="pricing-cta" data-id="element-86">
            <div className="text-center mb-8 md:mb-10" data-id="element-87">
              <p className="text-body/50 text-base md:text-lg font-light mb-1" data-id="element-88">
                Valore Totale: <span className="line-through" data-id="element-89">€497</span>
              </p>
              <p className="font-heading text-5xl md:text-7xl font-extrabold text-cta tracking-tight leading-none mb-3" data-id="element-90">
                PREZZO OGGI: €67
              </p>
            </div>

            <div className="mb-8" data-id="element-91">
              <CTAButton onClick={handleCheckout} className="w-full text-lg md:text-xl py-5" data-id="element-92">
                SÌ, VOGLIO ACCEDERE ORA (€67)
              </CTAButton>
            </div>
          </div>

          <div className="flex justify-center items-center gap-3 text-[10px] md:text-xs text-body/40 mb-3" data-id="element-93">
            <span data-id="element-94">💳 Visa</span>
            <span data-id="element-95">💳 Mastercard</span>
            <span data-id="element-96">💰 PayPal</span>
            <span data-id="element-97">🍎 Apple Pay</span>
          </div>
          <p className="text-center text-[10px] md:text-xs text-body/40 mb-10" data-id="element-98">
            🔒 Pagamento 100% Sicuro e Criptato
          </p>

          <div className="flex items-center gap-4 bg-gray-50 rounded-brand p-5 md:p-6 mb-10" data-id="element-99">
            <div className="w-14 h-14 bg-green-50 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-100">
              <ShieldCheck className="w-7 h-7 text-green-600" strokeWidth={1.5} data-id="element-101" />
            </div>
            <div data-id="element-102">
              <h3 className="font-heading font-bold text-headline text-sm md:text-base mb-1" data-id="element-103">
                14 Giorni Soddisfatti o Rimborsati
              </h3>
              <p className="text-body text-xs md:text-sm font-light leading-relaxed" data-id="element-104">
                Se non sei soddisfatto, ti rimborsiamo ogni centesimo. Nessuna
                domanda.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}